import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseQueryOptions,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

const QUERY_KEY = ['studios', 'public-schedule-token'] as const;

export interface PublicScheduleTokenResponse {
  token: string | null;
  publicId: string | null;
}

export const getPublicScheduleTokenAPI = async () => {
  const response = await baseAPI.get<PublicScheduleTokenResponse>(
    '/studios/public-schedule-token',
  );
  return response.data;
};

export type PublicScheduleTokenScope = 'classes' | 'events';

export const generatePublicScheduleTokenAPI = async (
  scope?: PublicScheduleTokenScope,
) => {
  const url =
    scope != null
      ? `/studios/public-schedule-token?scope=${encodeURIComponent(scope)}`
      : '/studios/public-schedule-token';
  const response = await baseAPI.post<{ token: string; publicId: string }>(url);
  return response.data;
};

export function usePublicScheduleToken(
  options?: Omit<
    UseQueryOptions<PublicScheduleTokenResponse>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: getPublicScheduleTokenAPI,
    ...options,
  });
}

export function useGeneratePublicScheduleToken() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (scope?: PublicScheduleTokenScope) =>
      generatePublicScheduleTokenAPI(scope),
    onSuccess: (data) => {
      queryClient.setQueryData<PublicScheduleTokenResponse>(QUERY_KEY, {
        token: data.token,
        publicId: data.publicId,
      });
    },
  });
}
